module.exports = new __parcel__URL__("masters-of-doom.fc534c2f.jpg").toString();